<template>
  <nav v-if="show" class="app-tabbar">
    <button
      v-for="item in navItems"
      :key="item.key"
      type="button"
      class="tab-item"
      :class="{ on: active === item.key }"
      @click="go(item)"
    >
      <span class="tab-icon">
        <svg
          v-if="item.key === 'home'"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M3 10.5L12 3l9 7.5"></path>
          <path d="M5 9.5V21h14V9.5"></path>
        </svg>

        <svg
          v-else-if="item.key === 'game'"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 3l7 4v5c0 5-3.5 7.74-7 9-3.5-1.26-7-4-7-9V7l7-4z"></path>
        </svg>

        <svg
          v-else-if="item.key === 'video'"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="5" width="18" height="14" rx="3"></rect>
          <path d="M10 9l5 3-5 3V9z"></path>
        </svg>

        <svg
          v-else-if="item.key === 'live'"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="2" y="6" width="20" height="12" rx="2"></rect>
          <path d="M8 6V4h8v2"></path>
        </svg>

        <svg
          v-else
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M20 21a8 8 0 1 0-16 0"></path>
          <circle cx="12" cy="8" r="4"></circle>
        </svg>
      </span>
      <span class="tab-label">{{ item.label }}</span>
    </button>
  </nav>
</template>

<script>
export default {
  props: {
    is_show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      active: "",
    };
  },
  computed: {
    navItems() {
      return [
        { key: "home", path: "/Home", label: this.$t("foorter.index") },
        { key: "game", path: "/Game", label: this.$t("foorter.cert") || "认证" },
        { key: "video", path: "/Video", label: this.$t("foorter.video") },
        { key: "live", path: "/Live", label: this.$t("foorter.live") || "直播" },
        { key: "mine", path: "/Mine", label: this.$t("foorter.my") },
      ];
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.syncState();
      },
    },
    is_show: {
      immediate: true,
      handler() {
        this.syncState();
      },
    },
  },
  methods: {
    syncState() {
      const routeName = this.$route && this.$route.name;
      const showRoutes = ["home", "game", "video", "live", "mine", "profile", "Lottery"];
      this.show = this.is_show || showRoutes.includes(routeName);
      if (routeName === "profile") {
        this.active = "home";
        return;
      }
      if (routeName === "Lottery") {
        this.active = "game";
        return;
      }
      if (routeName === "CrushList") {
        this.active = "mine";
        return;
      }
      this.active = showRoutes.includes(routeName) ? routeName : "";
    },
    go(item) {
      if (this.$route.path === item.path) {
        return;
      }
      this.$router.push(item.path);
    },
  },
};
</script>

<style lang="less" scoped>
.app-tabbar {
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 80;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: start;
  width: min(100%, 25rem);
  height: calc(4.625rem + env(safe-area-inset-bottom));
  padding: 0.4375rem 0.5625rem max(0.4375rem, env(safe-area-inset-bottom));
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(16, 10, 21, 0.94);
  box-shadow: 0 -0.75rem 1.875rem rgba(0, 0, 0, 0.22);
  transform: translateX(-50%);
  backdrop-filter: blur(1.25rem);
  -webkit-backdrop-filter: blur(1.25rem);
}

.tab-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  height: 3.625rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.56);
}

.tab-item.on {
  color: #ff6e9b;
}

.tab-item.on::before {
  content: "";
  position: absolute;
  top: -0.5rem;
  width: 2rem;
  height: 0.1875rem;
  border-radius: 0 0 0.25rem 0.25rem;
  background: linear-gradient(90deg, #a55cff, #ff3f78);
  box-shadow: 0 0.1875rem 0.625rem rgba(255, 63, 120, 0.5);
}

.tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.625rem;
  height: 1.625rem;
}

.tab-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}

.tab-label {
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

button {
  cursor: pointer;
}

@media (max-width: 47.9375rem) {
  .app-tabbar {
    width: min(100%, 24.25rem);
    height: calc(4.875rem + env(safe-area-inset-bottom));
    padding: 0.5rem 0.625rem max(0.5rem, env(safe-area-inset-bottom));
  }

  .tab-item {
    height: 3.875rem;
  }

  .tab-icon {
    width: 1.875rem;
    height: 1.875rem;
  }

  .tab-icon svg {
    width: 1.75rem;
    height: 1.75rem;
  }

  .tab-label {
    font-size: 0.8125rem;
  }
}

@media (max-width: 22.5rem) {
  .app-tabbar {
    width: min(100%, 23.5rem);
  }

  .tab-label {
    font-size: 0.75rem;
  }
}
</style>
